import SelectOption from "../../components/select_option"
import usePegawai from "./usePegawai"
import Select from "react-select";
import DataTable from "react-data-table-component"
import TrueOrFalseModal from "../../components/true_or_false_modal";
import debounce from 'lodash.debounce'
import { useCallback } from "react";
import AsyncSelect from "react-select/async"


const PegawaiPage = () => {
    const {
        data,
        isAdd,
        isEdit,
        isValid,
        columns,
        loading,
        perPage,
        formData,
        isSubmit,
        totalRows,
        roleAppId,
        aplikasiId,
        currentPage,
        isPassValid,
        isAllowEdit,
        isAllowDelete,
        valueRoleAppId,
        modalRef,
        isSubmitTrueOrFalse,
        dataTrueOrFalseModal,
        handleSubmitTrueOrFalse,
        handleOpenTrueOrFalseModal,
        navigate,
        handleShowForm,
        handleSubmitForm,
        handlePageChange,
        handleChangeForm,
        handleRowSelected,
        handlePerRowsChange,
        handleAddAplikasiId,
        handleDeleteAplikasiId,
        allSatker,
        allSatkerOptions,
        getAllSatker,
        formDataSatker,
        setFormDataSatker,
        isNip18Digits,
        isRole2,
        pegawaiOptions,
        selectedPegawai,
        setSelectedPegawai,
        getPegawaiOptions,
        handleJadikanPimpinan,
        kodeSatkerUtama,
        isRole1,
        setKeyword,
        handleResetOTP
    } = usePegawai()
    const debouncedPegawaiSearch = useCallback(
        debounce((input, callback) => {
            getPegawaiOptions(input)
            callback(pegawaiOptions)
        }, 500),
        [pegawaiOptions]
    )

    const debouncedSearch = useCallback(
        debounce((value) => {
            getAllSatker(value)
        }, 500),
        []
    )

    return (
        <>
            <div className="modal fade" id="userModal" tabIndex="-1" aria-labelledby="userModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="userModalLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div >
                                <form onSubmit={handleSubmitForm}>
                                    <div
                                    //</form>className="rounded-4 p-4 card" style={{
                                    // border: "1px solid black" 
                                    //}}
                                    >
                                        {(isEdit) &&
                                            <>
                                                <label htmlFor="nip" className="col-form-label">NIP</label>
                                                <input
                                                    type="text"
                                                    name="nip"
                                                    value={formData.nip}
                                                    // pattern="^(-|\d{18})$"
                                                    className="form-control"
                                                    onChange={handleChangeForm}
                                                />
                                            </>
                                        }
                                        <label htmlFor="nama" className="col-form-label">Nama</label>
                                        <input type="text" name="nama" value={formData.nama} className="form-control" onChange={handleChangeForm} />
                                        <label htmlFor="no_hp" className="col-form-label">No. Hp</label>
                                        <input type="text" name="no_hp" value={formData.no_hp} className="form-control" onChange={handleChangeForm} />
                                        <label htmlFor="email" className="col-form-label">Email</label>
                                        <input type="email" name="email" value={formData.email} className="form-control" onChange={handleChangeForm} />
                                        <label htmlFor="kode_satker" className="col-form-label">Kode Satker</label>
                                        <Select
                                            options={allSatkerOptions}
                                            name="kode_satker_utama"
                                            id="kode_satker_utama"
                                            value={formDataSatker.kode_satker_utama} // ✅ object
                                            onChange={(option) => {
                                                setFormDataSatker({
                                                    ...formDataSatker,
                                                    kode_satker_utama: option,
                                                })
                                            }}
                                            onInputChange={(inputValue, { action }) => {
                                                if (action === 'input-change') {
                                                    debouncedSearch(inputValue)
                                                }
                                            }}
                                            placeholder="Satuan Kerja Utama..."
                                            isClearable
                                        />

                                        {/* <input type="text" name="kode_satker" value={formData.kode_satker} className="form-control" onChange={handleChangeForm} /> */}
                                        <div className="d-flex justify-content-between align-items-center">
                                            <label htmlFor="aplikasi_role" className="col-form-label">Aplikasi Role</label>
                                            <div className="badge text-primary" style={{ cursor: "pointer" }} onClick={() => handleAddAplikasiId()}><i className="bi bi-plus"></i> Tambah Aplikasi</div>
                                        </div>
                                        {
                                            aplikasiId.map((e, index) => (
                                                <div className="d-flex flex-row mb-3" key={index}>
                                                    <div className="w-100">
                                                        <SelectOption
                                                            index={index}
                                                            url={"/v1/aplikasi"}
                                                            to={`aplikasi_id`}
                                                            placeholder={"Pilih Aplikasi"}
                                                            selectedOption={e}
                                                            required={!isEdit}
                                                            handleChangeSelectOption={handleChangeForm}
                                                        />
                                                    </div>
                                                    <div className="m-1"></div>
                                                    <div className="w-100">
                                                        <Select
                                                            // isDisabled={aplikasiId[index] === null}
                                                            name="role_app_id"
                                                            placeholder="Pilih Role"
                                                            value={valueRoleAppId ? valueRoleAppId[index] : {}}
                                                            options={roleAppId[index]}
                                                            onChange={handleChangeForm}
                                                        />
                                                    </div>
                                                    <div className="m-1"></div>
                                                    <div className={`btn btn-outline-danger ${aplikasiId.length < 2 ? "disabled" : ""}`} onClick={() => handleDeleteAplikasiId(index)}><i className="bi bi-x"></i></div>
                                                </div>
                                            ))
                                        }
                                        <label htmlFor="password" className="col-form-label">Password</label>
                                        <input
                                            type="password"
                                            name="password"
                                            value={formData.password}
                                            className="form-control"
                                            onChange={handleChangeForm}
                                            disabled={isNip18Digits}
                                        />

                                        <label htmlFor="password_confirmation" className="col-form-label">
                                            Password Confirmation
                                        </label>

                                        <input
                                            type="password"
                                            name="password_confirmation"
                                            value={formData.password_confirmation}
                                            className="form-control"
                                            onChange={handleChangeForm}
                                            disabled={isNip18Digits}
                                        />

                                        <p>Password harus minimal 10 karakter dengan huruf besar, huruf kecil, dan karakter spesial (misalnya #)</p>
                                        {
                                            isPassValid ? <></> :
                                                <><span className="badge text-danger">Pastikan Password dan Password Confirmation sama, dan memiliki minimal 10 karakter dengan huruf besar, huruf kecil, dan karakter spesial (misalnya #)</span><br /></>
                                        }
                                        <button className="btn btn-outline-primary mt-3" disabled={!isValid || isSubmit}>{isSubmit ? "Menyimpan..." : "Simpan"}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* } */}
            <div className="row" style={{ padding: "36px" }}>
                <div className="col-12">
                    <h1 className="d-flex justify-content-center mb-4 title-home">Pegawai / Pejabat</h1>
                    <div className="row justify-content-center mb-4">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12" >
                            <div className="row">
                                <div className="col-2 d-flex justify-content-center">
                                    <div className="circle-button" onClick={() => { navigate(-1) }}>
                                        <i className="bi bi-arrow-left"></i>
                                        Back
                                    </div>
                                </div>

                                {isRole1 && (
                                    <div className="col-2 d-flex justify-content-center">
                                        <div className="circle-button" data-bs-toggle="modal" data-bs-target="#userModal" onClick={() => {

                                            handleShowForm()
                                        }} >
                                            {
                                                // isAdd ?
                                                //     <i className="bi bi-x-lg"></i> :
                                                <i className="bi bi-plus-lg"></i>
                                            }
                                            Add
                                        </div>
                                    </div>
                                )}
                                {isRole1 && (
                                    <div className="col-2 d-flex justify-content-center">
                                        <div data-bs-toggle="modal" data-bs-target="#userModal" className={`circle-button ${isAllowEdit ? "" : "disabled"}`} onClick={isAllowEdit ? () => {

                                            handleShowForm(true)
                                        } : () => { }} >
                                            {
                                                // isEdit && 
                                                // isAllowEdit ?
                                                //     <i className="bi bi-x-lg"></i> :
                                                <i className="bi bi-pencil"></i>
                                            }
                                            Update
                                        </div>
                                    </div>

                                )}

                                {isRole1 && (
                                <div className="col-2 d-flex justify-content-center">
                                    <div className={`circle-button ${isAllowEdit ? "" : "disabled"}`}
                                        onClick={isAllowEdit ? () => handleResetOTP() : () => { }} >
                                        <i className="bi bi-shield-lock"></i>
                                        Reset OTP
                                    </div>
                                </div>
                                )}
                                {isRole1 && (
                                    <div className="col-2 d-flex justify-content-center">
                                        <div className={`circle-button deleted ${isAllowDelete ? "" : "disabled"}`} onClick={isAllowDelete ? () => handleOpenTrueOrFalseModal() : () => { }} >
                                            <i className="bi bi-trash"></i> Delete
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="mt-4" />
                    {isRole2 && (
                        <div className=" row justify-content-center">
                            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12" style={{ paddingRight: "1rem", paddingLeft: "1rem", }}>

                                <div className="card p-3 mb-4">
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions   // loads first time with empty keyword
                                        loadOptions={getPegawaiOptions}  // ✅ return promise of options
                                        value={selectedPegawai}
                                        onChange={setSelectedPegawai}
                                        placeholder="Cari pegawai..."
                                        isClearable
                                        onInputChange={(inputValue, { action }) => {
                                            if (action === "input-change") {
                                                setKeyword(inputValue);
                                            }
                                        }}
                                    />

                                    {/* <label className="mt-2">Pilih Satker</label>
                            <Select
                                options={allSatkerOptions}
                                value={formDataSatker.kode_satker_utama}
                                onChange={(opt) =>
                                    setFormDataSatker({ kode_satker_utama: opt })
                                }
                            /> */}

                                    <button
                                        className="btn btn-success mt-3"
                                        onClick={handleJadikanPimpinan}
                                    >
                                        Jadikan Pimpinan Satker
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 mb-4" style={{ paddingRight: "1rem", paddingLeft: "1rem", }}>
                            <div className="rounded-4 card"
                                style={{
                                    // border: "1px solid black", 
                                    paddingBottom: "16px"
                                }}
                            >
                                {
                                    loading ?
                                        <div className="text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div> :
                                        <DataTable
                                            customStyles={{
                                                headCells: {
                                                    style: {
                                                        fontWeight: 'bold',
                                                        fontSize: "16px"
                                                    },
                                                },
                                            }}
                                            columns={columns}
                                            data={data}
                                            progressPending={loading}
                                            selectableRows
                                            selectableRowsSingle
                                            pagination
                                            paginationServer
                                            paginationPerPage={perPage}
                                            paginationTotalRows={totalRows}
                                            paginationDefaultPage={currentPage}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onChangePage={handlePageChange}
                                            onSelectedRowsChange={handleRowSelected}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <TrueOrFalseModal modalRef={modalRef} handleSubmit={handleSubmitTrueOrFalse} isSubmit={isSubmitTrueOrFalse} modalTitle={dataTrueOrFalseModal.title} modalDesc={dataTrueOrFalseModal.description} />
            </div>
        </>
    )
}
export default PegawaiPage